import './feedback-component.scss';
var FeedbackComponent = /** @class */ /*@__PURE__*/ (function () {
    function FeedbackComponent() {
    }
    return FeedbackComponent;
}());
export { FeedbackComponent };
